import { ChangeDetectorRef, Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, combineLatestWith, Observable, Subject, takeUntil } from 'rxjs';
import { AuthService, hasInternalPermission, LoHiUserInfo } from '../services/auth.service';
import { InternalService } from '../services/internal.service';

@Directive({
  selector: '[tdFranchiseOrInternal]',
  standalone: false,
})
export class FranchiseOrInternalDirective implements OnDestroy {
  private hasView = false;
  private destroy$$ = new Subject<void>();
  private userInfo$: Observable<LoHiUserInfo>;

  private elseTemplateRef$$ = new BehaviorSubject<TemplateRef<any>>(null);

  @Input()
  public set tdFranchiseOrInternal(_: void) {}

  @Input()
  public set tdFranchiseOrInternalElse(templateRef: TemplateRef<any>) {
    this.elseTemplateRef$$.next(templateRef);
  }

  constructor(
    private authService: AuthService,
    private internalService: InternalService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private cd: ChangeDetectorRef,
  ) {
    this.userInfo$ = this.authService.userInfo$;
    this.listenForViewUpdates();
  }

  public ngOnDestroy(): void {
    this.destroy$$.next();
    this.destroy$$.unsubscribe();
  }

  private listenForViewUpdates() {
    this.userInfo$
      .pipe(
        takeUntil(this.destroy$$),
        combineLatestWith(this.elseTemplateRef$$, this.internalService.isInternalShared$),
      )
      .subscribe(([userInfo, elseRef, isInternal]) => {
        if (userInfo?.isOtrFranchisee || isInternal) {
          this.clearView();
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
          this.cd.markForCheck();
        } else {
          this.clearView();
          if (elseRef) {
            this.viewContainer.createEmbeddedView(elseRef);
            this.hasView = true;
          }
          this.cd.markForCheck();
        }
      });
  }

  private clearView() {
    if (this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
      this.cd.markForCheck();
    }
  }
}
